import { Fragment, ReactElement, useMemo } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import PersonsPageNonResident from 'mutation/pages/registration-civil-union/non-resident/search-person';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { ResearchNotifications } from 'notifications-from-civil-status/view-models/notifications-list';

interface ResearchCivilUnionNonResidentNotificationSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  editSipoUrl?: string;
  items?: BreadcrumbItem[];
}

const ResearchCivilUnionNonResidentNotificationShared = ({
  goBackUrl = '',
  redirectUrl = '',
  items = [],
  editSipoUrl = '',
}: ResearchCivilUnionNonResidentNotificationSharedProps): ReactElement => {
  const filterTable = useFilterTable<ResearchNotifications>();

  const initialValues = useMemo(() => {
    return {
      fiscalCode: filterTable.values?.searchPersonFiscalCode,
      surname: filterTable.values?.searchPersonSurname,
      name: filterTable.values?.searchPersonName,
      birthday: filterTable.values?.searchPersonDateBorn,
    };
  }, [filterTable.values]);

  return (
    <Fragment>
      <Breadcrumbs items={items} />
      <PersonsPageNonResident
        addedTitle="Registrazione Unione Civile Non Residenti"
        goBackUrl={goBackUrl}
        editSipoUrl={editSipoUrl}
        redirectUrl={redirectUrl}
        isWithoutBreadcrumb
        initialValues={initialValues}
      />
    </Fragment>
  );
};

ResearchCivilUnionNonResidentNotificationShared.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default ResearchCivilUnionNonResidentNotificationShared;
